import { TASKS_API_ENDPOINT } from "../../../constants/constant";
import baseApi from "../../baseApi";
import {
  ApiResponse,
  ResultType,
  Task,
  TasksAnalytics,
  UserQueryParams,
} from "./tasks.type";

export const tasksApiSlice = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getTasksAnalyticsApiCall: build.query<
      ApiResponse<TasksAnalytics>,
      UserQueryParams | void
    >({
      query: (params) => {
        const queryParams = new URLSearchParams();
        if (params?.campaignId)
          queryParams.append("campaignId", params.campaignId);

        // if (params?.search) queryParams.append("search", params.search);
        // if (params?.status) queryParams.append("status", params.status);

        return `${
          TASKS_API_ENDPOINT.GET_TASKS_ANALYTICS
        }?${queryParams.toString()}`;
      },
      providesTags: ["TasksAnalytics"],
    }),

    getTasksApiCall: build.query<
      ApiResponse<ResultType<Task>>,
      UserQueryParams | void
    >({
      query: (params) => {
        const queryParams = new URLSearchParams();
        if (params?.campaignId)
          queryParams.append("campaignId", params.campaignId);
        if (params?.search) queryParams.append("search", params.search);
        if (params?.page) queryParams.append("page", params.page.toString());
        if (params?.limit) queryParams.append("limit", params.limit.toString());
        return `${TASKS_API_ENDPOINT.GET_TASKS}?${queryParams.toString()}`;
      },
      providesTags: ["Tasks"],
    }),

    createTaskApiCall: build.mutation<ApiResponse<ResultType<Task>>, any>({
      query: (tasksBody) => ({
        url: TASKS_API_ENDPOINT.CREATE_TASK,
        method: "POST",
        body: tasksBody,
      }),
      invalidatesTags: ["Tasks", "TasksAnalytics"],
    }),

    updateTaskApiCall: build.mutation<ApiResponse<ResultType<Task>>, any>({
      query: (tasksBody) => ({
        url: TASKS_API_ENDPOINT.UPDATE_TASK,
        method: "PUT",
        body: tasksBody,
      }),
      invalidatesTags: ["Tasks", "TasksAnalytics"],
    }),

    changeCampaignsTaskStatusApiCall: build.mutation<ApiResponse, any>({
      query: (campaignsBody) => ({
        url: `${TASKS_API_ENDPOINT.CHANGE_TASK_STATUS}?taskId=${campaignsBody.taskId}&status=${campaignsBody.status}`,
        method: "PUT",
      }),
      invalidatesTags: ["Tasks", "TasksAnalytics"],
    }),
  }),
});

export const {
  useGetTasksApiCallQuery,
  useUpdateTaskApiCallMutation,
  useCreateTaskApiCallMutation,
  useGetTasksAnalyticsApiCallQuery,
  useChangeCampaignsTaskStatusApiCallMutation,
} = tasksApiSlice;

export default tasksApiSlice;
